import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "File Explorer", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeFolder = _resolveComponent("TreeFolder")!
  const _component_MountedExecute = _resolveComponent("MountedExecute")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "filetree-container",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reMount()))
    }, [
      _hoisted_1,
      (_ctx.cvStore.fileTreeRoot)
        ? (_openBlock(), _createBlock(_component_TreeFolder, {
            key: 0,
            onFileOpened: _cache[0] || (_cache[0] = (fileSelected) => _ctx.$emit('fileOpened', fileSelected)),
            data: _ctx.cvStore.fileTreeRoot
          }, null, 8, ["data"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MountedExecute, {
      onNowMounted: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reMount()))
    })
  ], 64))
}